define('collections/base/baseCollection',[
        'backbone',
        'underscore',
        'mixins/backbone/syncEvent'
    ],
    function (Backbone, _, syncMixin) {
        'use strict';
        return Backbone.Collection.extend(_.extend(syncMixin));
    });
